// extracted by mini-css-extract-plugin
module.exports = {"c1dn3z8p":"c1dn3z8p"};